import BackgroundImg2 from "../components/BackgroundImg2/BackgroundImg2"
import AboutContent from "../components/AboutContent/AboutContent"
import Footer from "../components/Footer/Footer"

const About = () => {
  return (
    <div>
      <BackgroundImg2 heading='ABOUT' text='Get to know me' />
      <AboutContent />
      <Footer />
    </div>
  )
}

export default About